import { Typography, IconButton, Link } from "@mui/material";

export const IconTextButton = ({ icon, text, href }) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    underline="none"
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      color: "white",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    }}
  >
    <IconButton
      sx={{
        padding: 0,
        color: "white",
        display: "flex",
        "& svg": {
          fontSize: { xs: "34px", sm: "28px" }, // larger on xs (mobile), default on sm+
        },
      }}
    >
      {icon}
    </IconButton>
    <Typography
      fontWeight="bold"
      sx={{
        display: { xs: "none", sm: "block" },
      }}
    >
      {text}
    </Typography>
  </Link>
);


  